export default [
    {
        id: 1,
        on: true,
        disabled: false,
        
    },   
    {
        id: 2,
        on: true,
        disabled: false,
        
    },   
    {
        id: 3,
        on: true,
        disabled: false,
        
    },   
    {
        id: 4,
        on: true,
        disabled: false,
        
    },   
    {
        id: 5,
        on: true,
        disabled: false,
        
    },   
    {
        id: 6,
        on: true,
        disabled: false,
        
    },   
    {
        id: 7,
        on: true,
        disabled: false,
        
    },   
    {
        id: 8,
        on: true,
        disabled: false,
        
    },   
    {
        id: 9,
        on: true,
        disabled: false,
        
    },   
    {
        id: 10,
        on: true,
        disabled: false,
        
    },   
    {
        id: 11,
        on: true,
        disabled: false,
        
    },   
    {
        id: 12,
        on: true,
        disabled: false,
        
    },
    {
        id: 13,
        on: true,
        disabled: false,
            
    },   
    {
        id: 14,
        on: true,
        disabled: false,
            
    },   
    {
        id: 15,
        on: true,
        disabled: false,
            
    },
    {
        id: 16,
        on: true,
        disabled: false,
        
    },   
    {
        id: 17,
        on: true,
        disabled: false,
        
    },   
    {
        id: 18,
        on: true,
        disabled: false,
        
    },
    {
        id: 19,
        on: true,
        disabled: false,
        
    },   
    {
        id: 20,
        on: true,
        disabled: false,
        
    },   
    {
        id: 21,
        on: true,
        disabled: false,
        
    },   
    {
        id: 22,
        on: true,
        disabled: false,
        
    },   
    {
        id: 23,
        on: true,
        disabled: false,
        
    },   
    {
        id: 24,
        on: true,
        disabled: false,
        
    },   
    {
        id: 25,
        on: true,
        disabled: false,
        
    },   
    {
        id: 26,
        on: true,
        disabled: false,
        
    },   
    {
        id: 27,
        on: true,
        disabled: false,
        
    },   
    {
        id: 28,
        on: true,
        disabled: false,
        
    },   
    {
        id: 29,
        on: true,
        disabled: false,
        
    },   
    {
        id: 30,
        on: true,
        disabled: false,
        
    },
    {
        id: 31,
        on: true,
        disabled: false,
            
    },   
    {
        id: 32,
        on: true,
        disabled: false,
            
    },   
    {
        id: 33,
        on: true,
        disabled: false,
            
    },
    {
        id: 34,
        on: true,
        disabled: false,
        
    },   
    {
        id: 35,
        on: true,
        disabled: false,
        
    },   
    {
        id: 36,
        on: true,
        disabled: false,
        
    },
]
